import HubertSwitch from 'components/HubertUI/HubertSwitch';
import HubertLabel from 'components/HubertUI/HubertLabel';
import HubertPopover from 'components/HubertUI/HubertPopover';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionForceOptionsReadout, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateVoiceSettings } from 'rtk/Question.Editor.Slice';
import { ECreateQuestionMode, useQuestionEditorContext } from '../../context/create-question.context';
import UneditableInfoTooltip from '../../UneditableInfoTooltip';

const FIELD_ID = 'create-question-force-options-readout';

// Per-question voice setting ("Enumerate options"): when on, the voice assistant reads the answer
// options aloud. Default (off) speaks the question on its own, without listing options — reading
// them annoys candidates and voice-web shows them on screen. See chat-backend renderSpokenQuestion.
const ForceOptionsReadoutSwitch = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const forceOptionsReadout = useAppSelector((state) => selectQuestionForceOptionsReadout(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  const disabled = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div className="py-1.5">
      <div className="flex flex-row items-center justify-between gap-4">
        <div className="flex min-w-0 flex-row items-center gap-1.5">
          <HubertLabel htmlFor={FIELD_ID} className="cursor-pointer truncate">
            {t('voiceSettings.forceOptionsReadout.label')}
          </HubertLabel>
          <HubertPopover>
            <HubertPopover.Trigger>
              <Info className="h-3.5 w-3.5 cursor-pointer text-gray-400 hover:text-gray-600" />
            </HubertPopover.Trigger>
            <HubertPopover.Content className="max-w-[360px] p-3">
              <div className="text-sm leading-relaxed text-gray-700">
                {t('voiceSettings.forceOptionsReadout.description')}
              </div>
            </HubertPopover.Content>
          </HubertPopover>
        </div>
        <UneditableInfoTooltip disabled={disabled}>
          <HubertSwitch
            id={FIELD_ID}
            disabled={disabled}
            checked={forceOptionsReadout}
            onCheckedChange={(checked: boolean) => {
              dispatch(updateVoiceSettings({ questionId, settings: { force_options_readout: checked } }));
            }}
          />
        </UneditableInfoTooltip>
      </div>
    </div>
  );
};

export default ForceOptionsReadoutSwitch;
